import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { EngagementAdminConfig } from '@/generated/graphql';
import { configChanged } from '@/providers/AdminEngagementProvider/actions';
import { useAdminEngagementContext } from '@/providers/AdminEngagementProvider/AdminEngagementContext';
import { StringArrayKeys } from '@/types/common';
import { PlusIcon, TrashIcon } from '@radix-ui/react-icons';

export function StringArrayConfigInput<TConfig extends EngagementAdminConfig>({
  configKey,
  placeholder,
}: {
  configKey: StringArrayKeys<TConfig>;
  placeholder?: string;
}) {
  const { state, dispatch } = useAdminEngagementContext();
  const value = ((state.config as TConfig)?.[configKey] as string[]) ?? [];

  return (
    <div className="flex flex-col gap-2">
      {value.map((v: string, i: number) => (
        <div key={i} className="flex gap-2">
          <Input
            value={v}
            placeholder={placeholder}
            onChange={(e) => {
              const newValue = [...value];
              newValue[i] = e.target.value;
              dispatch(configChanged({ config: { [configKey]: newValue } }));
            }}
          />
          <Button
            variant="outline"
            size="icon"
            onClick={() => {
              dispatch(
                configChanged({
                  config: { [configKey]: value.filter((_, j) => j !== i) },
                }),
              );
            }}
          >
            <TrashIcon />
          </Button>
        </div>
      ))}
      <Button
        variant="outline"
        size="icon"
        onClick={() => {
          dispatch(configChanged({ config: { [configKey]: [...value, ''] } }));
        }}
      >
        <PlusIcon />
      </Button>
    </div>
  );
}
